import { NgModule } from '@angular/core'
import { provideConfig } from '@spartacus/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TRAINING_CATEGORIES_CONVERTER } from './index'
import { TrainingCategoriesConverter } from './training-categories.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        trainingCategoriesFeature: {
          module: () => import('./training-categories.module').then((m) => m.TrainingCategoriesModule),
          cmsComponents: ['training_categories'],
        },
      }
    }),
    {
      provide: TRAINING_CATEGORIES_CONVERTER,
      useExisting: TrainingCategoriesConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        training_categories: TRAINING_CATEGORIES_CONVERTER
      },
      multi: true
    }
  ]
})
export class TrainingCategoriesFeatureModule {
}
